import RMModal from 'components/modal/RMModal';
import React from 'react';
import { SeedFormulationModal, SeedFormulationProps } from './SeedFormulationModal';
import { FmlxModal } from 'fmlx-common-ui';

export const SeedFormulation = (props: SeedFormulationProps) => {
  return (
    <RMModal
      id="seed-formulatrix-rm-modal"
      showModal={props.show}
      setShowModal={props.setShow}
      showButtons={false}
      body={<SeedFormulationModal {...props} isNew={true} />}
      dialogClassName={'modal-seedformulation'}
      heading={'Create Seed'}
      okButtonText={'Save'}
      noButtonText={'Cancel'}
      size={FmlxModal.Size.DOUBLE_EXTRA_LARGE}
    />
  );
};
